export const categories = [{
  id: 0,
  name: 'Gestion d\'entreprise',
  image:'gestion-entreprise.jpeg'
}, {
  id: 1,
  name: 'Langues',
  image:'langues.jpeg'
}, {
  id: 2,
  name: 'Informatique et Logiciel',
  image:'informatique-logiciel.jpeg'
}, {
  id: 3,
  name: 'Bureautique',
  image:'bureautique.jpeg'
}, {
  id: 4,
  name: 'Développement personnel',
  image:'developpement-personnel.jpeg'
}];

export const souscategories = [{
  id: 0,
  idCategorie:0,
  name: 'Marketing - Création d\'entreprise',
  icon:'fa fa-briefcase'
}, {
  id: 1,
  idCategorie:0,
  name: 'Sécurité - Prévention',
  icon:'fa fa-shield'
}, {
  id: 2,
  idCategorie:0,
  name: 'Cybersécurité',
  icon:'fa fa-lock'
}, {
  id: 3,
  idCategorie:0,
  name: 'R.G.P.D',
  icon:'fa fa-file'
}, {
  id: 4,
  idCategorie:1,
  name: 'Anglais',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 5,
  idCategorie:1,
  name: 'Espagnol',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 6,
  idCategorie:1,
  name: 'Allemand',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 7,
  idCategorie:1,
  name: 'REFLEX Français',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 8,
  idCategorie:2,
  name: 'Wordpress',
  icon:'fa fa-desktop'
}, {
  id: 9,
  idCategorie:2,
  name: 'Photoshop',
  icon:'fa fa-pencil-square'
}, {
  id: 10,
  idCategorie:2,
  name: 'Illustrator',
  icon:'fa fa-pencil-square'
}, {
  id: 11,
  idCategorie:2,
  name: 'Indesign',
  icon:'fa fa-pencil-square'
}, {
  id: 12,
  idCategorie:2,
  name: 'Autodesk',
  icon:'fa fa-pencil-square'
}, {
  id: 13,
  idCategorie:2,
  name: 'Développement web / Web Mobile',
  icon:'fa fa-code'
}, {
  id: 14,
  idCategorie:3,
  name: 'Secrétariat - Comptabilité + Excel',
  icon:'fa fa-phone-square'
}, {
  id: 15,
  idCategorie:3,
  name: 'Secrétariat - Spécialité domaine de la santé + Excel',
  icon:'fa fa-phone-square'
}, {
  id: 16,
  idCategorie:3,
  name: 'CléA Numérique',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 17,
  idCategorie:3,
  name: 'Dactylographie',
  icon:'fa fa-pencil-square'
}, {
  id: 18,
  idCategorie:3,
  name: 'Bases Informatiques',
  icon:'fa fa-desktop'
}, {
  id: 19,
  idCategorie:3,
  name: 'Windows',
  icon:'fa fa-desktop'
}, {
  id: 20,
  idCategorie:3,
  name: 'Bureautique Microsoft Office 2016',
  icon:'fa fa-desktop'
}, {
  id: 21,
  idCategorie:3,
  name: 'Bureautique Microsoft Office 2019',
  icon:'fa fa-desktop'
}, {
  id: 22,
  idCategorie:3,
  name: 'Bureautique Microsoft Office 2016/2013/2010 - Tutoriels Vidéo',
  icon:'fa fa-desktop'
}, {
  id: 23,
  idCategorie:4,
  name: 'OnlineCléA',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 24,
  idCategorie:4,
  name: 'Savoir de base',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 25,
  idCategorie:4,
  name: 'Projet Professionnel',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 26,
  idCategorie:4,
  name: 'Entraînement Cognitif',
  icon:'fa-regular fa-comment-dots'
}, {
  id: 27,
  idCategorie:4,
  name: 'Technique de recherche d\'emploi (T.R.E)',
  icon:'fa-regular fa-comment-dots'
}];

export const formations = [{
  id: 0,
  idCategorie:0,
  idSousCategorie:0,
  name:'Management',
  nbHeures : 15,
  tarif:110,
  optionTutorat:0,
  description:'',
}, {
  id: 1,
  idCategorie:0,
  idSousCategorie:0,
  name: 'Réseaux sociaux, Community Manager',
  nbHeures : 20,
  tarif:89,
  optionTutorat:0,
  description:'',
}, {
  id: 2,
  idCategorie:0,
  idSousCategorie:0,
  name: 'Création d\'entreprise',
  nbHeures : 14,
  tarif:59,
  optionTutorat:0,
  description:'',
}, {
  id: 3,
  idCategorie:0,
  idSousCategorie:1,
  name: 'Catégorie 1 : Préparations aux habilitations électriques',
  nbHeures : 0,
  tarif:80,
  optionTutorat:0,
  description:'',
}, {
  id: 4,
  idCategorie:0,
  idSousCategorie:1,
  name: 'Catégorie 2 : Levage (Chariots - PEMP - etc …)',
  nbHeures : 0,
  tarif:45,
  optionTutorat:0,
  description:'',
}, {
  id: 5,
  idCategorie:0,
  idSousCategorie:1,
  name: 'Autres formations du catalogue',
  nbHeures : 0,
  tarif:25,
  optionTutorat:0,
  description:'',
}, {
  id: 6,
  idCategorie:0,
  idSousCategorie:1,
  name: 'Gestes et postures, hygiène sécurité, environnement',
  nbHeures : 0,
  tarif:40,
  optionTutorat:0,
  description:'',
}, {
  id: 7,
  idCategorie:0,
  idSousCategorie:2,
  name: 'Cybersécurité',
  nbHeures : 26,
  tarif:69,
  optionTutorat:0,
  description:'',
}, {
  id: 8,
  idCategorie:0,
  idSousCategorie:3,
  name: 'R.G.P.D pour vous',
  nbHeures : 4,
  tarif:55,
  optionTutorat:0,
  description:'',
}, {
  id: 9,
  idCategorie:1,
  idSousCategorie:4,
  name: 'Travel First (Grand débutant)',
  nbHeures : 40,
  tarif:70,
  optionTutorat:220,
  description:'',
}, {
  id: 10,
  idCategorie:1,
  idSousCategorie:4,
  name: 'Level 1 + Speak & Revise Level 1 + Révision Gram/Voca A1/A2',
  nbHeures : 100,
  tarif:90,
  optionTutorat:220,
  description:'',
}, {
  id: 11,
  idCategorie:1,
  idSousCategorie:4,
  name: 'Level 2 + Speak & Revise Level 2 (à venir en janvier) +Révision Gram/Voca B1/B2',
  nbHeures : 100,
  tarif:90,
  optionTutorat:220,
  description:'',
}, {
  id: 12,
  idCategorie:1,
  idSousCategorie:4,
  name: 'Level 3 + Speak & Revise Level 3 +Révision Gram/Voca C1/C2',
  nbHeures : 100,
  tarif:90,
  optionTutorat:220,
  description:'',
}, {
  id: 13,
  idCategorie:1,
  idSousCategorie:4,
  name: 'Business First',
  nbHeures : 20,
  tarif:70,
  optionTutorat:220,
  description:'',
}, {
  id: 14,
  idCategorie:1,
  idSousCategorie:5,
  name: 'Reflex Espagnol Niveau 1 + Révision Grammaire et vocabulaire A1/A2',
  nbHeures : 80,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 15,
  idCategorie:1,
  idSousCategorie:5,
  name: 'Reflex Espagnol Niveau 2 + Révision Grammaire et vocabulaire B1/B2',
  nbHeures : 80,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 16,
  idCategorie:1,
  idSousCategorie:5,
  name: 'Reflex Espagnol Niveau 3 + Révision Grammaire et vocabulaire C1/C2',
  nbHeures : 80,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 17,
  idCategorie:1,
  idSousCategorie:6,
  name: 'Reflex Deutch Révision Vocabulaire/Gramaire A1/A2',
  nbHeures : 40,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 18,
  idCategorie:1,
  idSousCategorie:6,
  name: 'Reflex Deutch Révision Vocabulaire/Gramaire B1/B2',
  nbHeures : 40,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 19,
  idCategorie:1,
  idSousCategorie:6,
  name: 'Reflex Deutch Révision Vocabulaire/Gramaire C1/C2',
  nbHeures : 40,
  tarif:75,
  optionTutorat:0,
  description:'',
}, {
  id: 20,
  idCategorie:1,
  idSousCategorie:7,
  name: 'Reflex’Français des Affaires',
  nbHeures : 20,
  tarif:50,
  optionTutorat:120,
  description:'',
}, {
  id: 21,
  idCategorie:1,
  idSousCategorie:7,
  name: 'Reflex’Français Grammaire + Vocabulaire - A1/A2',
  nbHeures : 30,
  tarif:50,
  optionTutorat:120,
  description:'',
}, {
  id: 22,
  idCategorie:2,
  idSousCategorie:8,
  name: 'Tutoriels Vidéos WORDPRESS',
  nbHeures : 16,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 23,
  idCategorie:2,
  idSousCategorie:8,
  name: 'Tutoriels Vidéos WOOCOMERCE',
  nbHeures : 4,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 24,
  idCategorie:2,
  idSousCategorie:8,
  name: 'Tutoriels Vidéos WORDPRESS + WOOCOMERCE',
  nbHeures : 20,
  tarif:80,
  optionTutorat:120,
  description:'',
}, {
  id: 25,
  idCategorie:2,
  idSousCategorie:9,
  name: 'Tutoriels Vidéos PHOTOSHOP - Initiation',
  nbHeures : 10,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 26,
  idCategorie:2,
  idSousCategorie:9,
  name: 'Tutoriels Vidéos PHOTOSHOP - Perfectionnement',
  nbHeures : 10,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 27,
  idCategorie:2,
  idSousCategorie:9,
  name: 'Tutoriels Vidéos PHOTOSHOP - Initiation + Perfectionnement',
  nbHeures : 10,
  tarif:80,
  optionTutorat:120,
  description:'',
}, {
  id: 28,
  idCategorie:2,
  idSousCategorie:10,
  name: 'Tutoriels Vidéos ILLUSTRATOR - Initiation',
  nbHeures : 10,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 29,
  idCategorie:2,
  idSousCategorie:10,
  name: 'Tutoriels Vidéos ILLUSTRATOR - Perfectionnement',
  nbHeures : 10,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 30,
  idCategorie:2,
  idSousCategorie:10,
  name: 'Tutoriels Vidéos ILLUSTRATOR - Initiation + Perfectionnement',
  nbHeures : 10,
  tarif:80,
  optionTutorat:120,
  description:'',
}, {
  id: 31,
  idCategorie:2,
  idSousCategorie:11,
  name: 'Tutoriels Vidéos INDESIGN - Initiation',
  nbHeures : 7,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 32,
  idCategorie:2,
  idSousCategorie:11,
  name: 'Tutoriels Vidéos INDESIGN - Perfectionnement',
  nbHeures : 7,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 33,
  idCategorie:2,
  idSousCategorie:11,
  name: 'Tutoriels Vidéos INDESIGN - Initiation + Perfectionnement',
  nbHeures : 14,
  tarif:80,
  optionTutorat:120,
  description:'',
}, {
  id: 34,
  idCategorie:2,
  idSousCategorie:12,
  name: 'Tutoriels Vidéos AUTOCAD 2022',
  nbHeures : 26,
  tarif:95,
  optionTutorat:150,
  description:'',
}, {
  id: 35,
  idCategorie:2,
  idSousCategorie:12,
  name: 'Tutoriels Vidéos AUTOCAD',
  nbHeures : 10,
  tarif:55,
  optionTutorat:150,
  description:'',
}, {
  id: 36,
  idCategorie:2,
  idSousCategorie:12,
  name: 'Tutoriels Vidéos AUTODESK REVIT 2021',
  nbHeures : 12,
  tarif:70,
  optionTutorat:150,
  description:'',
}, {
  id: 37,
  idCategorie:2,
  idSousCategorie:13,
  name: 'BOOSTRAP (Formation interactive)',
  nbHeures : 13,
  tarif:40,
  optionTutorat:120,
  description:'',
}, {
  id: 38,
  idCategorie:2,
  idSousCategorie:13,
  name: 'GITHUB (Formation interactive)',
  nbHeures : 4,
  tarif:40,
  optionTutorat:30,
  description:'',
}, {
  id: 39,
  idCategorie:2,
  idSousCategorie:13,
  name: 'HTML - CSS (Formation interactive + Tutoriels vidéos)',
  nbHeures : 50,
  tarif:90,
  optionTutorat:150,
  description:'',
}, {
  id: 40,
  idCategorie:2,
  idSousCategorie:13,
  name: 'JAVASCRIPT (Formation interactive + Tutoriels vidéos)',
  nbHeures : 47,
  tarif:90,
  optionTutorat:150,
  description:'',
}, {
  id: 41,
  idCategorie:2,
  idSousCategorie:13,
  name: 'JQUERY (Formation interactive + Tutoriels vidéos)',
  nbHeures : 15,
  tarif:60,
  optionTutorat:60,
  description:'',
}, {
  id: 42,
  idCategorie:2,
  idSousCategorie:13,
  name: 'PHP - SQL (Formation interactive + Tutoriels vidéos)',
  nbHeures : 40,
  tarif:90,
  optionTutorat:120,
  description:'',
}, {
  id: 43,
  idCategorie:2,
  idSousCategorie:13,
  name: 'PYTHON (Formation interactive)',
  nbHeures : 13,
  tarif:40,
  optionTutorat:80,
  description:'',
}, {
  id: 0,
  idCategorie:2,
  idSousCategorie:13,
  name: 'SAAS (Formation interactive)',
  nbHeures : 3,
  tarif:30,
  optionTutorat:30,
  description:'',
}, {
  id: 0,
  idCategorie:2,
  idSousCategorie:13,
  name: 'BASH - SHELL (Formation interactive)',
  nbHeures : 2,
  tarif:20,
  optionTutorat:30,
  description:'',
}, {
  id: 0,
  idCategorie:2,
  idSousCategorie:13,
  name: 'HTTP - RESEAU - SECURITÉ (Formation interactive)',
  nbHeures : 7,
  tarif:60,
  optionTutorat:60,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:14,
  name: 'Secrétariat - Comptabilité + Excel',
  nbHeures : 35,
  tarif:60,
  optionTutorat:120,
  description:'Assistante secrétaire (12h) + Lire et comprendre un bilan (15h) + Excel 2016 (niveau au choix : débutant, intérmédiaire ou expert) (9h)',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:15,
  name: 'Secrétariat - Spécialité domaine de la santé + Excel',
  nbHeures : 50,
  tarif:60,
  optionTutorat:120,
  description:'Préparation aux concours paramédicaux + Quiz formatifs Biologie (33h) + Assistante secrétaire (12h) + Excel 2016 (niveau au choix : débutant, intérmédiaire ou expert) (9h)',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:16,
  name: 'CLÉA Numérique',
  nbHeures : 50,
  tarif:60,
  optionTutorat:120,
  description:'Accès aux 4 domaines de compétences',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:17,
  name: 'Dactyloraphie',
  nbHeures : 20,
  tarif:45,
  optionTutorat:0,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:18,
  name: 'Bases Informatiques',
  nbHeures : 30,
  tarif:55,
  optionTutorat:120,
  description:'Manier la souris sans soucis (6h) + Premiers pas informatique (20h) + Sécurité informatique (1h) + Travail collaboratif (1h) + Les outils du travail collaboratif (2h)',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:19,
  name: 'Windows 10',
  nbHeures : 8,
  tarif:40,
  optionTutorat:60,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:19,
  name: 'Windows 10 - Video',
  nbHeures : 4,
  tarif:22,
  optionTutorat:60,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Microsoft Office Word',
  nbHeures : 30,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Microsoft Office Excel',
  nbHeures : 30,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Microsoft Office PowerPoint',
  nbHeures : 25,
  tarif:50,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Microsoft Office Outlook',
  nbHeures : 15,
  tarif:40,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Pack Initiation Bureautique (Word + Excel + Powerpoint + Outlook + Windows 10)',
  nbHeures : 40,
  tarif:80,
  optionTutorat:160,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Pack Perfectionnement Bureautique (Word + Excel + Powerpoint + Outlook)',
  nbHeures : 30,
  tarif:65,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Pack Expert Bureautique (Word + Excel + Powerpoint + Outlook)',
  nbHeures : 30,
  tarif:65,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Pack ESSENTIEL Bureautique (Word + Excel complets)',
  nbHeures : 60,
  tarif:100,
  optionTutorat:200,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:20,
  name: 'Pack Office INTEGRAL (Word + Excel + Powerpoint + Outlook complets)',
  nbHeures : 100,
  tarif:125,
  optionTutorat:300,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Microsoft Office Word',
  nbHeures : 30,
  tarif:70,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Microsoft Office Excel',
  nbHeures : 30,
  tarif:70,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Microsoft Office PowerPoint',
  nbHeures : 25,
  tarif:60,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Microsoft Office Outlook',
  nbHeures : 15,
  tarif:45,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Pack Initiation Bureautique ( Word + Excel + Powerpoint + Outlook + Windows 10)',
  nbHeures : 40,
  tarif:90,
  optionTutorat:160,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Pack Perfectionnement Bureautique (Word + Excel + Powerpoint + Outlook)',
  nbHeures : 30,
  tarif:75,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Pack Expert Bureautique (Word + Excel + Powerpoint + Outlook)',
  nbHeures : 30,
  tarif:75,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Pack ESSENTIEL Bureautique (Word + Excel Complet)',
  nbHeures : 60,
  tarif:110,
  optionTutorat:200,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:21,
  name: 'Pack Office INTEGRAL (Word + Excel + Powerpoint + Outlook)',
  nbHeures : 100,
  tarif:135,
  optionTutorat:300,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:22,
  name: 'Microsoft Office Word - Vidéo',
  nbHeures : 5,
  tarif:25,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:22,
  name: 'Microsoft Office Excel - Vidéo',
  nbHeures : 5,
  tarif:25,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:22,
  name: 'Microsoft Office PowerPoint - Vidéo',
  nbHeures : 5,
  tarif:22,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:3,
  idSousCategorie:22,
  name: 'Microsoft Office Outlook - Vidéo',
  nbHeures : 4,
  tarif:22,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:23,
  name: 'OnlineCléa',
  nbHeures : 350,
  tarif:110,
  optionTutorat:150,
  description:'La communication en français; Calcul et raisonnement mathématique;Information et communication numérique;Travailler en équipe;Travailler en autonomie;Apprendre à apprendre;Gestes et postures, hygiène sécurité, environnement;Complément CléA',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:24,
  name: 'Savoirs de base Français',
  nbHeures : 100,
  tarif:70,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:24,
  name: 'Savoirs de base Mathématiques',
  nbHeures : 100,
  tarif:70,
  optionTutorat:120,
  description:'',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:25,
  name: 'Aptipost : évaluation des aptitudes',
  nbHeures : 6,
  tarif:30,
  optionTutorat:0,
  description:'',
}
, {
  id: 0,
  idCategorie:4,
  idSousCategorie:25,
  name: 'CLÉO : les CLÉs de l’Orientation',
  nbHeures : 3,
  tarif:30,
  optionTutorat:0,
  description:'',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:25,
  name: 'Évaluation des compétences',
  nbHeures : 3,
  tarif:30,
  optionTutorat:0,
  description:'',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:26,
  name: 'Entraînement cognitif',
  nbHeures :80,
  tarif:55,
  optionTutorat:0,
  description:'Modules d\'entraînement cognitif',
}, {
  id: 0,
  idCategorie:4,
  idSousCategorie:27,
  name: 'Technique de recherche d\'emploi (T.R.E)',
  nbHeures :10,
  tarif:35,
  optionTutorat:0,
  description:'',
}




];